const cmAppraisalValuesTemplate = `<!DOCTYPE html>
<html>
  <head>
   
  </head>
  <body>
    <div id="appraisalValues">
    <div class="heading"><h6>Appraisal &nbsp; Value &nbsp; (Values &nbsp; in &nbsp;{{currency}} )</h2></div>

      <table>
        <tr>
          <th></th>
          <th>Property Value</th>
          <th>Cap Rate</th>
          <th>Property Value Date</th>
          <th>Report Date</th>
        </tr>
        <tr>
          <td class="leftAlign">As-Is</td>
          <td class ="rightAlign">{{currencySymbol}}{{ asIsPropertyValue}}</td>
          <td class ="rightAlign">{{ asIscapRate}}</td>
          <td>{{ propertyAsIsDate}}</td>
          <td>{{reportDate}}</td>
        </tr>
        <tr>
          <td class="leftAlign">Stabilized</td>
          <td class ="rightAlign">{{currencySymbol}}{{ stabilizedValue}}</td>
          <td class ="rightAlign">{{stabilizedcapRate}}</td>
          <td>{{propertyStabilizedDate}}</td>
          <td></td>
        </tr>
        <tr>
          <td class="leftAlign">Land Value</td>
          <td class ="rightAlign">{{currencySymbol}}{{ landValue}}</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td class="leftAlign">Insurable Value</td>
          <td class ="rightAlign">{{currencySymbol}}{{ insurableValue}}</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <!-- Additional rows with 9 columns -->
        </tr>
      </table>
    </div>
  </body>
</html>
`;
export default cmAppraisalValuesTemplate;


// <style>
// body {
//   font-family: Roboto, Helvetica, Arial, sans-serif;
// }
// table,
// th,
// td {
//   border: none;
//   padding-top: 10px;
// }
// table {
//   width: 100%;
//   border-radius: 3px !important;
// }
// th,
// td {
//   padding: 15px;
// }
// .border {
//   width: 100%;
//   border: 0.5px solid #263746;
//   border-radius: 3px;
// }

// .heading {
//   margin: 0 !important;
//   background-color: #263746;
//   color: #fff;
//   padding: 10px;
// }

// th > .leftAlign {
//   align-items: left !important;
//   justify-content: left !important;
//   text-align: left !important;
// }
// </style>